import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Channel } from 'icreate/common/models/channel';
import { AlarmPropertyList } from 'icreate/common/models/repose-group';

interface FormOption {
    panelTitle: string;
    property: AlarmPropertyList;
}

@Component({
    selector: 'app-channel-panel-alarm-forms-list',
    templateUrl: './channel-panel-alarm-forms-list.component.html',
    styleUrls: ['./channel-panel-alarm-forms-list.component.scss'],
    standalone: false,
})
export class ChannelPanelAlarmFormsListComponent {
    @Input() newChannel: Channel;
    @Input() isAnalog: boolean;
    @Input() isRunning: boolean;
    @Input() isFlow: boolean;
    @Input() isExhGasDev: boolean;
    @Input() isExhGasMean: boolean;
    @Input() isDigitalMotor: boolean;

    @Output() onChannelChange = new EventEmitter<{ name: string; value: any; property: string }>();
    @Output() onFocusChange = new EventEmitter<void>();

    readonly ANALOG_ALARM_FORMS: FormOption[] = [
        { panelTitle: 'channel.label.alarm.high-high', property: AlarmPropertyList.alarmSettingVeryHigh },
        { panelTitle: 'channel.label.alarm.high', property: AlarmPropertyList.alarmSettingHigh },
        { panelTitle: 'channel.label.alarm.low', property: AlarmPropertyList.alarmSettingLow },
        { panelTitle: 'channel.label.alarm.low-low', property: AlarmPropertyList.alarmSettingVeryLow },
        { panelTitle: 'channel.label.alarm.sensor-failure', property: AlarmPropertyList.alarmSettingSensorFail },
    ];

    readonly EXH_GAS_DEV_ALARM_FORMS: FormOption[] = [
        { panelTitle: 'channel.label.alarm.high-high', property: AlarmPropertyList.alarmSettingVeryHigh },
        { panelTitle: 'channel.label.alarm.high', property: AlarmPropertyList.alarmSettingHigh },
        { panelTitle: 'channel.label.alarm.low', property: AlarmPropertyList.alarmSettingLow },
        { panelTitle: 'channel.label.alarm.low-low', property: AlarmPropertyList.alarmSettingVeryLow },
    ];

    readonly EXH_GAS_MEAN_ALARM_FORMS: FormOption[] = [
        { panelTitle: 'channel.label.alarm.low', property: AlarmPropertyList.alarmSettingLow },
    ];

    readonly FLOW_RUNNING_ALARM_FORMS: FormOption[] = [
        { panelTitle: 'channel.label.alarm.high-high', property: AlarmPropertyList.alarmSettingVeryHigh },
        { panelTitle: 'channel.label.alarm.high', property: AlarmPropertyList.alarmSettingHigh },
    ];

    readonly MOTOR_ALARM_FORMS = [
        { panelTitle: 'channel.alarm.form.motor.stop-status', property: 'stopStatusString' },
        { panelTitle: 'channel.alarm.form.motor.stby-status', property: 'stbyStatusString' },
        { panelTitle: 'channel.alarm.form.motor.run-status-1', property: 'runStatusString1' },
        { panelTitle: 'channel.alarm.form.motor.run-status-2', property: 'runStatusString2' },
        { panelTitle: 'channel.alarm.form.motor.run-status-3', property: 'runStatusString3' },
        { panelTitle: 'channel.alarm.form.motor.run-status-4', property: 'runStatusString4' },
        { panelTitle: 'channel.alarm.form.motor.run-status-5', property: 'runStatusString5' },
    ];

    isToggleDisabled(formOption: FormOption) {
        const property = formOption.property;
        if (property == AlarmPropertyList.alarmSettingVeryHigh) {
            if (this.newChannel?.fcuData?.[AlarmPropertyList.alarmSettingHigh]?.enable == false) return true;
        } else if (property == AlarmPropertyList.alarmSettingVeryLow) {
            if (this.newChannel?.fcuData?.[AlarmPropertyList.alarmSettingLow]?.enable == false) return true;
        }
        return false;
    }
}
